import React from 'react';
import { registerWidget } from '../widgetRegistry';
import { useLayoutCtx } from '../LayoutContext';

// Granular Add-Task widget — Cancel + Launch buttons. Reads `busy` from
// useLayoutCtx().draft (host modal flips it true while the launch POST is
// in flight); fires onSubmit / onCancel back through callbacks.

const btnPrimary = { background: 'var(--accent-color)', color: '#fff', border: 'none', borderRadius: '6px', padding: '7px 14px', cursor: 'pointer', fontWeight: 600, fontSize: '13px' };
const btnSecondary = { background: 'var(--bg-tertiary)', color: 'var(--text-primary)', border: '1px solid var(--border-color)', borderRadius: '6px', padding: '7px 14px', cursor: 'pointer', fontSize: '13px' };

function AddTaskToolbar({ config }) {
  const { draft, callbacks, bus } = useLayoutCtx();
  const busy = !!draft?.busy;
  const showCancel = config.show_cancel !== false;
  const submitLabel = config.submit_label || 'Launch';

  const fire = (name) => {
    if (callbacks && typeof callbacks[name] === 'function') callbacks[name]();
    if (bus && typeof bus.publish === 'function') {
      bus.publish(name === 'onSubmit' ? 'xv.AddTaskSubmitted' : 'xv.AddTaskCancelled', { draft });
    }
  };

  return (
    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '14px', paddingTop: '12px', borderTop: '1px solid var(--border-color)' }}>
      {showCancel && (
        <button onClick={() => fire('onCancel')} disabled={busy} style={btnSecondary}>Cancel</button>
      )}
      <button onClick={() => fire('onSubmit')} disabled={busy} style={btnPrimary}>
        {busy ? 'Launching…' : submitLabel}
      </button>
    </div>
  );
}

registerWidget({
  type: 'add_task.toolbar',
  categories: ['add_task'],
  palette_label: 'Add Task toolbar',
  description: 'Cancel + Launch action row. Fires onSubmit / onCancel on the host modal; "Launching…" while busy.',
  Component: AddTaskToolbar,
  configSchema: {
    fields: [
      { type: 'boolean', name: 'show_cancel', label: 'Show "Cancel"', default: true },
      { type: 'text', name: 'submit_label', label: 'Submit button label', default: 'Launch' },
    ],
  },
  publishes: ['xv.AddTaskSubmitted', 'xv.AddTaskCancelled'],
  subscribes: [],
  group: 'Add Task',
});
